import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { MapPin, X } from 'lucide-react';
import { useTheme } from './ui/theme-provider';
import { cn } from '../lib/utils';

const LocationPrompt = ({ onLocationSubmit, onClose, loading }) => {
  const [postcode, setPostcode] = useState('');
  const { theme } = useTheme();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (postcode.trim()) {
      onLocationSubmit(postcode.trim());
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className={cn(
        "w-full max-w-md",
        theme === 'light' ? 'bg-white' : 'bg-gray-800'
      )}>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-lg font-semibold">
            <MapPin className="inline w-5 h-5 mr-2" />
            Set Your Location
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-6 w-6 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Enter your postcode to see jobs sorted by distance. This helps you find opportunities near you.
          </p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="text"
              placeholder="e.g. SW1A 1AA"
              value={postcode}
              onChange={(e) => setPostcode(e.target.value)}
              className="uppercase"
              disabled={loading}
            />
            <div className="flex gap-2">
              <Button 
                type="submit" 
                disabled={loading || !postcode.trim()}
                className={cn(
                  "bg-purple-600 hover:bg-purple-700 text-white border-0",
                  "dark:bg-purple-600 dark:hover:bg-purple-700 dark:text-white",
                  "disabled:opacity-50 disabled:cursor-not-allowed",
                  "font-medium px-4 py-2 rounded-md"
                )}
              >
                {loading ? 'Finding Location...' : 'Set Location'}
              </Button>
              <Button 
                type="button" 
                variant="outline" 
                onClick={onClose}
                className={cn(
                  "border-gray-300 text-gray-700 hover:bg-gray-50",
                  "dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                )}
              >
                Skip for Now
              </Button>
            </div>
          </form>
          <p className="text-xs text-gray-500 mt-3">
            You can update this later in your profile settings.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LocationPrompt;
